import React, { Fragment, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { CollectAcceptType } from '../../../util/collect-accept-type';

import { VariableActions } from '../../../store/actions/variables';

import Checkbox from '../../Elements/Checkbox';
import Select from '../../Select';

export default (props) => {
  const {
    answerHandlerOpen,
    toggleAnswerHandler,
    doUpdateItem,
    item,
    variable,
    onVariableUpdate,
    match,
  } = props;

  const { i18n } = useTranslation();
  const { variables } = useSelector((state) => state.variables.variablesState);

  const dispatch = useDispatch();
  const { botid: botId } = match.params;

  const acceptAll = item.acceptFiles.length === 6;
  const acceptImage =
    item.acceptFiles && item.acceptFiles.includes(CollectAcceptType.Image);
  const acceptDocument =
    item.acceptFiles && item.acceptFiles.includes(CollectAcceptType.Document);
  const acceptAudio =
    item.acceptFiles && item.acceptFiles.includes(CollectAcceptType.Audio);
  const acceptVideo =
    item.acceptFiles && item.acceptFiles.includes(CollectAcceptType.Video);
  const acceptCompact =
    item.acceptFiles && item.acceptFiles.includes(CollectAcceptType.Compact);
  const acceptText =
    item.acceptFiles && item.acceptFiles.includes(CollectAcceptType.Text);

  const formattedVariableOptions = useMemo(() => {
    return variables && variables.bot
      ? variables.bot.map((_variable) => ({
          value: _variable.name,
          label: _variable.name,
        }))
      : [];
  }, [variables]);

  const selectedVariableToSelect = useMemo(() => {
    if (!formattedVariableOptions) return null;

    const findVariable = formattedVariableOptions.find(
      (_variable) => _variable.value === variable
    );

    if (findVariable) return findVariable;

    return null;
  }, [formattedVariableOptions, variable]);

  const handleChangeVariable = useCallback(
    (arrayWithNewValue) => {
      const newVariable = !arrayWithNewValue
        ? { value: '', label: '' }
        : arrayWithNewValue.find(
            (newVariable) => newVariable.value !== variable
          );

      onVariableUpdate(newVariable.value);
    },
    [variable]
  );

  const handleCreateVariableOption = useCallback(
    (inputValue) => {
      const payload = {
        botId,
        type: 'user',
        active: true,
        name: inputValue,
        value: '',
      };

      dispatch(VariableActions.create(payload));
      onVariableUpdate(inputValue);
    },
    [dispatch, botId]
  );

  const commitItem = () => {
    const { botid } = props.match.params;
    doUpdateItem({
      botid,
      itemid: item._id,
      acceptFiles: item.acceptFiles,
      collectSuccessMessage: item.collectSuccessMessage,
      collectErrorMessage: item.collectErrorMessage,
    });
  };

  const onAcceptedFileChanged = (e, type) => {
    if (e.target.checked) {
      if (type === CollectAcceptType.All) {
        item.acceptFiles = [
          CollectAcceptType.Image,
          CollectAcceptType.Document,
          CollectAcceptType.Audio,
          CollectAcceptType.Video,
          CollectAcceptType.Compact,
          CollectAcceptType.Text,
        ];
      } else {
        if (!item.acceptFiles.includes(type)) {
          item.acceptFiles.push(type);
        }
      }
    } else {
      if (type === CollectAcceptType.All) {
        item.acceptFiles = [];
      } else {
        if (item.acceptFiles.includes(type)) {
          item.acceptFiles.splice(item.acceptFiles.indexOf(type), 1);
        }
      }
    }
    commitItem();
  };

  return (
    <Fragment>
      {/* OPÇÕES DE COLETA */}
      <p className="pointer handler-title" onClick={toggleAnswerHandler}>
        Opções de coleta{' '}
        <img
          alt=""
          className={
            'seta-expander ' + (!answerHandlerOpen ? 'arrow-rotation' : '')
          }
          src="/assets/images/icons/seta_close.svg"
        />
      </p>

      <div className="form-group mt-1" hidden={!answerHandlerOpen}>
        <Select
          label="Salvar identificação para variável"
          options={formattedVariableOptions}
          value={selectedVariableToSelect}
          onChange={(value) => handleChangeVariable(value)}
          onCreateOption={(value) => handleCreateVariableOption(value)}
          isMulti
          isCreatable
        />

        <label>Aceitar arquivos</label>
        <div className="mt-1">
          <Checkbox
            label={i18n.t('Todos')}
            type={CollectAcceptType.All}
            checked={acceptAll}
            onChange={(e, type) => onAcceptedFileChanged(e, type)}
          />
          <Checkbox
            label={i18n.t('Imagem')}
            type={CollectAcceptType.Image}
            checked={acceptImage}
            onChange={(e, type) => onAcceptedFileChanged(e, type)}
          />
          <Checkbox
            label={i18n.t('Documento')}
            type={CollectAcceptType.Document}
            checked={acceptDocument}
            onChange={(e, type) => onAcceptedFileChanged(e, type)}
          />
          <Checkbox
            label={i18n.t('Áudio')}
            type={CollectAcceptType.Audio}
            checked={acceptAudio}
            onChange={(e, type) => onAcceptedFileChanged(e, type)}
          />
          <Checkbox
            label={i18n.t('Vídeo')}
            type={CollectAcceptType.Video}
            checked={acceptVideo}
            onChange={(e, type) => onAcceptedFileChanged(e, type)}
          />
          <Checkbox
            label={i18n.t('Compactados')}
            type={CollectAcceptType.Compact}
            checked={acceptCompact}
            onChange={(e, type) => onAcceptedFileChanged(e, type)}
          />
          <Checkbox
            label={i18n.t('Texto')}
            type={CollectAcceptType.Text}
            checked={acceptText}
            onChange={(e, type) => onAcceptedFileChanged(e, type)}
          />
        </div>
      </div>
    </Fragment>
  );
};
